// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__d1TB4","errorText":"ErrorPage_errorText__7JJo6","link":"ErrorPage_link__pHomo"};